import { render, staticRenderFns } from "./app_global_snackbar.vue?vue&type=template&id=4bbad1cb&scoped=true&"
import script from "./app_global_snackbar.vue?vue&type=script&lang=ts&"
export * from "./app_global_snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./app_global_snackbar.vue?vue&type=style&index=0&id=4bbad1cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbad1cb",
  null
  
)

export default component.exports